<template>
  <v-autocomplete
    :autocomplete="autocomplete"
    placeholder="Commencer à saisir pour lancer la recherche"
    v-model="pays"
    :loading="loading"
    :search-input.sync="recherche"
    :items="listePays"
    no-filter
    v-bind="$attrs"
    v-on="$listeners"
    :data-testid="dataTestid"
  />
</template>

<script>
import _ from "lodash";
import { paysService } from "@/services";
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      loading: false,
      items: [],
      recherche: null,
      default: ["FRANCE"],
      pays: this.value,
      autocomplete: Math.random().toString(36).slice(2) // Génère une chaîne aléatoire pour bloquer l'autocomplete des navigateurs
    };
  },

  mounted() {
    this.debouncedQuery = _.debounce(this.query.bind(this), 250);
  },

  methods: {
    query(recherche) {
      this.loading = true;
      paysService
        .autocomplete(recherche)
        .then(items => {
          this.items = items;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    demarreRecherche() {
      this.debouncedQuery(this.recherche);
    },
  },

  watch: {
    recherche() {
      this.demarreRecherche();
    },
    value() {
      this.pays = this.value;
    },
    pays() {
      if (this.value !== this.pays) {
        this.$emit("input", this.pays);
      }
    },
  },

  computed: {
    listePays() {
      const pays = this.recherche ? [...this.items] : [...this.default];
      if (this.value && pays.findIndex(c => c === this.value) < 0) {
        pays.push(this.value);
      }
      return pays;
    },
  }
};
</script>

